module.exports = __webpack_public_path__ + "1f6d3cf6d38f25d83d95f5a800b8cac3.woff2";